<div [ngClass]="{ tall: isTall }" class="audit-detail-list-v2">
  <div *ngIf="loading">Loading...</div>
  <div *ngIf="loaded">
    <div *ngIf="audits && audits.length > 0; else noAudits">
      <div *ngFor="let audit of audits">
        <sd-portal-audit-detail-v2 [audit]="audit"></sd-portal-audit-detail-v2>
      </div>
      <button
        *ngIf="hasMore"
        mat-button
        color="primary"
        (click)="nextPage.emit()"
        style="margin-top: 16px; width: 100%;"
      >
        Load More
      </button>
    </div>
    <ng-template #noAudits>
      <p style="padding: 16px; text-align: center; color: #666;">
        {{ noAuditsMessage }}
      </p>
    </ng-template>
  </div>
</div>
